/*
 * GOTU — pesquisa via Canivete (Postgres FTS) com fallback nativo.
 *
 * Estratégia defensiva: NÃO substitui o componente nativo de predictive search
 * do tema. Em vez disso, desenha um painel PRÓPRIO por cima. Quando o Canivete
 * devolve resultados, mostra o painel e esconde a lista nativa; quando a
 * pesquisa está desligada no painel, dá erro, ou não há resultados, esconde o
 * seu painel e deixa a pesquisa nativa da Shopify aparecer normalmente.
 *
 * Para desligar por completo: remover o <script> em snippets/search-modal.liquid.
 *
 * Endpoint: definido no atributo data-endpoint do <script> (ver search-modal.liquid).
 */
(function () {
  'use strict';

  var script = document.currentScript ||
    document.querySelector('script[src*="gotu-search"][data-endpoint]') ||
    document.querySelector('script[data-endpoint]');
  var ENDPOINT =
    (script && script.getAttribute('data-endpoint')) ||
    window.GOTU_SEARCH_ENDPOINT ||
    '';

  if (!ENDPOINT || !/^https?:\/\//.test(ENDPOINT)) {
    // Sem endpoint configurado — não faz nada, a pesquisa nativa mantém-se.
    return;
  }

  var DEBOUNCE_MS = 160;
  var MIN_CHARS = 2;

  function formatPrice(value) {
    if (value === null || value === undefined) return '';
    try {
      return new Intl.NumberFormat('pt-PT', {
        style: 'currency',
        currency: 'EUR',
      }).format(value);
    } catch (e) {
      return value + ' €';
    }
  }

  function thumb(url) {
    if (!url) return '';
    // Pedir uma versão pequena à CDN da Shopify quando possível.
    if (url.indexOf('cdn.shopify') !== -1 || url.indexOf('/cdn/') !== -1) {
      var sep = url.indexOf('?') === -1 ? '?' : '&';
      return url + sep + 'width=96';
    }
    return url;
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // Estado por instância de pesquisa (pode haver mais que uma na página).
  function getContext(input) {
    var wrapper = input
      .closest('.predictive-search-form')
      .querySelector('.predictive-search-form__content-wrapper');
    if (!wrapper) return null;

    var nativeContent = wrapper.querySelector('.predictive-search-form__content');
    var footer = wrapper.querySelector('.predictive-search-form__footer');

    var panel = wrapper.querySelector('.gotu-search-panel');
    if (!panel) {
      panel = document.createElement('div');
      panel.className = 'gotu-search-panel';
      panel.setAttribute('role', 'listbox');
      panel.style.cssText =
        'display:none;max-height:50dvh;overflow-y:auto;background:var(--color-background,#fff);' +
        'padding:8px;';
      wrapper.insertBefore(panel, wrapper.firstChild);
    }
    return { wrapper: wrapper, nativeContent: nativeContent, footer: footer, panel: panel };
  }

  function showNative(ctx) {
    ctx.panel.style.display = 'none';
    ctx.panel.innerHTML = '';
    if (ctx.nativeContent) ctx.nativeContent.style.display = '';
    if (ctx.footer) ctx.footer.style.removeProperty('display');
  }

  function showPanel(ctx) {
    if (ctx.nativeContent) ctx.nativeContent.style.display = 'none';
    if (ctx.footer) ctx.footer.style.display = 'none';
    ctx.panel.style.display = 'block';
  }

  function renderResults(ctx, term, results) {
    var html = results
      .map(function (r) {
        var price = formatPrice(r.price);
        var img = thumb(r.image);
        var soldout = r.available === false
          ? '<span style="font-size:0.72rem;color:var(--color-foreground,#666);opacity:0.6;margin-left:6px;">esgotado</span>'
          : '';
        return (
          '<a href="' + escapeHtml(r.url) + '" role="option" ' +
          'style="display:flex;align-items:center;gap:12px;padding:8px 10px;text-decoration:none;' +
          'color:var(--color-foreground,#111);border-radius:8px;">' +
          (img
            ? '<img src="' + escapeHtml(img) + '" alt="" loading="lazy" width="44" height="44" ' +
              'style="width:44px;height:44px;object-fit:cover;border-radius:6px;flex:0 0 auto;background:#f2f2f2;">'
            : '<span style="width:44px;height:44px;border-radius:6px;background:#f2f2f2;flex:0 0 auto;"></span>') +
          '<span style="flex:1;min-width:0;">' +
          '<span style="display:block;font-size:0.9rem;line-height:1.3;">' +
          escapeHtml(r.title) + soldout + '</span>' +
          (price
            ? '<span style="display:block;font-size:0.82rem;opacity:0.7;margin-top:2px;">' + price + '</span>'
            : '') +
          '</span>' +
          '</a>'
        );
      })
      .join('');

    ctx.panel.innerHTML =
      '<div style="font-size:0.72rem;letter-spacing:0.04em;text-transform:uppercase;opacity:0.55;' +
      'padding:6px 10px;">Produtos</div>' +
      html +
      '<a href="/search?q=' + encodeURIComponent(term) + '" ' +
      'style="display:block;text-align:center;padding:10px;font-size:0.85rem;font-weight:600;' +
      'text-decoration:none;color:var(--color-foreground,#111);border-top:1px solid var(--color-border,#eee);margin-top:6px;">' +
      'Ver todos os resultados</a>';
  }

  var timers = new WeakMap();
  var controllers = new WeakMap();
  var engineEnabled = null; // null = desconhecido; true/false após a 1ª resposta

  // Esconde o nativo já (antes do fetch) para não haver flash do menu antigo.
  // Mantém resultados anteriores visíveis enquanto carrega; só mostra
  // "A pesquisar…" na primeira consulta (painel ainda vazio).
  function showPanelLoading(ctx) {
    if (!ctx.panel.innerHTML) {
      ctx.panel.innerHTML =
        '<div style="padding:14px;font-size:0.85rem;opacity:0.6;">A pesquisar…</div>';
    }
    showPanel(ctx);
  }

  function onInput(input) {
    var ctx = getContext(input);
    if (!ctx) return;

    var term = (input.value || '').trim();
    if (term.length < MIN_CHARS) {
      showNative(ctx);
      return;
    }

    // Abortar pedido anterior desta instância.
    var prev = controllers.get(input);
    if (prev) prev.abort();
    var controller = new AbortController();
    controllers.set(input, controller);

    fetch(ENDPOINT + '?q=' + encodeURIComponent(term), {
      signal: controller.signal,
      headers: { Accept: 'application/json' },
    })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (data) {
        if (data) engineEnabled = (data.enabled !== false);

        // Ignorar respostas obsoletas (o termo mudou entretanto).
        if ((input.value || '').trim() !== term) return;

        if (!data || data.enabled === false || !data.results || data.results.length === 0) {
          showNative(ctx); // fallback para a pesquisa nativa
          return;
        }
        renderResults(ctx, term, data.results);
        showPanel(ctx);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        showNative(ctx); // qualquer falha -> fallback nativo
      });
  }

  // Delegação global: apanha todas as caixas de pesquisa do tema.
  document.addEventListener('input', function (e) {
    var input = e.target;
    if (!input || !input.classList || !input.classList.contains('search-input')) return;

    // Esconder o nativo imediatamente (antes do debounce/fetch) elimina o
    // flash do menu antigo. Se já soubermos que o motor está desligado,
    // não interferimos de todo.
    if (engineEnabled !== false) {
      var ctx = getContext(input);
      if (ctx) {
        if ((input.value || '').trim().length >= MIN_CHARS) {
          showPanelLoading(ctx);
        } else {
          showNative(ctx);
        }
      }
    }

    clearTimeout(timers.get(input));
    timers.set(input, setTimeout(function () { onInput(input); }, DEBOUNCE_MS));
  });

  // Ao limpar/fechar, repor o estado nativo.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.predictive-search__reset-button') : null;
    if (!btn) return;
    var form = btn.closest('.predictive-search-form');
    var input = form && form.querySelector('.search-input');
    if (input) {
      var ctx = getContext(input);
      if (ctx) showNative(ctx);
    }
  });
})();
